import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PopupModels } from "app/_core/_models/common/popup.models";
import { ButtonThemeState } from "app/shared";
@Component({
    selector: "dodo-popup-message-dialog",
    templateUrl: "./popup-message-dialog.component.html",
    styleUrls: ["./popup-message-dialog.component.scss"],
    standalone: false
})
export class PopupMessageDialogComponent implements OnInit {
	public title = "Having trouble?";
	public message =
		"Make sure you have the service you are porting handy and have entered the mobile number. The SMS verification code will be sent to the mobile number you wish to transfer. If you are still not received the SMS verification code, please call us on 13DODO and our friendly team can assist.";
	public subtitle = "";
	public icon = "";
	public buttonText = "CLOSE";
	public buttonColor = "primary";
	public secondButtonLink = "";
	public isNewSimkit = false;
	public buttonTheme = ButtonThemeState.GREEN;
	constructor(
		public dialogRef: MatDialogRef<PopupMessageDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: PopupModels.DialogMessage
	) {
		if (data) {
			this.title = data.Title;
			this.message = data.Instruction;
			this.subtitle = data.Subtitle;
			this.icon = data.Icon;
			this.buttonText = data.buttonText || "CLOSE";
			this.buttonColor = data.buttonColor || "primary";
			this.secondButtonLink = data.secondButtonLink || "";
			this.isNewSimkit = data.isNewSimkit || false;
		}
	}

	ngOnInit() {}

	public continueClicked() {
		console.log("continue button clicked ...");
	}

	public closeDialog(): void {
		this.dialogRef.close();
	}
	
	public secondButtonClicked() {
		window.location.href = this.secondButtonLink;
	}
}
